























import { Component, Vue, Prop } from 'vue-property-decorator';

import DateUtils from '@/utils/DateUtils';

import AdminService from '@/api/AdminService';
import eventBus from '@/utils/eventBus';

@Component({})
export default class TwismWalletSendCoinsHistory extends Vue {
  @Prop(String) businessId!: string;

  adminService: AdminService = new AdminService();

  activities: Record<string, any>[] = [];
  loading: boolean = true;
  next: string = '';

  async getActivities() {
    this.loading = true;
    try {
      const { data } = await this.adminService.getTwismSendCoinsHistory(
        this.businessId,
        this.next
      );

      const prepareData = data.map((activity: any) => ({
        ...activity,
        time: DateUtils.formatISOLongDate(activity.createdAt, true)
      }));

      this.activities = prepareData;
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    await this.getActivities();

    eventBus.$on('reloadTwismWalletHistory', this.getActivities);
  }

  beforeDestroy() {
    eventBus.$off('reloadTwismWalletHistory', this.getActivities);
  }
}
